import { alphabet } from '../constants';

/**
 * 按字母分组品牌
 * @param {Array} brands - 品牌数组
 * @returns {Object} 按字母分组的品牌对象
 */
export function groupBrandsByAlpha(brands) {
  const grouped = {};
  alphabet.forEach(letter => { grouped[letter] = []; });
  brands.forEach(b => {
    const first = b.brandName[0].toUpperCase();
    if (grouped[first]) grouped[first].push(b);
  });
  return grouped;
}

/**
 * 滚动到指定元素
 * @param {string} elementId - 元素ID
 */
export function scrollToElement(elementId) {
  const el = document.getElementById(elementId);
  if (el) {
    el.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }
} 


// 根据 categoryId 获取类别标签
export const getCategoryLabel = (categoryId, categories) => {
  const category = categories.find(c => c.value === categoryId);
  return category ? category.label : '';
};

// 处理HTML内容中的图片URL
export const processImageUrls = (htmlContent) => {
  if (!htmlContent) return htmlContent;
  
  // 服务端现在已经正确处理了所有字段，返回的是包含完整预签名URL的HTML
  // 直接返回原内容即可
  return htmlContent;
};

// 处理HTML内容中的图片URL
const processHtmlImages = (htmlContent) => {
  if (!htmlContent) return htmlContent;
  
  // 使用正则表达式查找所有img标签
  return htmlContent.replace(
    /<img\s+([^>]*?)src\s*=\s*["']([^"']+)["']([^>]*?)>/gi,
    (match, beforeSrc, src, afterSrc) => {
      console.log('找到图片标签，src:', src);
      
      // 如果src是相对路径（不以http开头），则添加S3基础URL
      if (src && !src.startsWith('http')) {
        const fullImageUrl = `https://s3.bitiful.net/breeze-snow/${src}`;
        console.log('转换图片URL:', src, '->', fullImageUrl);
        return `<img ${beforeSrc}src="${fullImageUrl}"${afterSrc} onerror="this.style.display='none';" />`;
      }
      
      // 如果已经是完整URL，只添加错误处理
      return `<img ${beforeSrc}src="${src}"${afterSrc} onerror="this.style.display='none';" />`;
    }
  );
};

// 测试函数 - 可以在浏览器控制台中调用
export const testImageUrlProcessing = () => {
  console.log('=== 测试图片URL处理 ===');
  
  // 测试1: 数据库中的HTML内容
  const testHtml1 = '<p><img src="2023032118262791.png" title="2023032118262791.png" alt="2023032118262791.png"/></p>';
  console.log('测试1 - 原始HTML:', testHtml1);
  console.log('测试1 - 处理后:', processImageUrls(testHtml1));
  
  // 测试2: 纯文件名
  const testFile2 = '2024042201294772.png';
  console.log('测试2 - 原始文件名:', testFile2);
  console.log('测试2 - 处理后:', processImageUrls(testFile2));
  
  // 测试3: 包含逗号的文件名
  const testFile3 = '5898, 2024042201294772.png';
  console.log('测试3 - 原始文件名:', testFile3);
  console.log('测试3 - 处理后:', processImageUrls(testFile3));
  
  // 测试4: 已经是完整URL的情况
  const testUrl4 = 'https://s3.bitiful.net/breeze-snow/test.png';
  console.log('测试4 - 原始URL:', testUrl4);
  console.log('测试4 - 处理后:', processImageUrls(testUrl4));
};
